import { Inject, Injectable, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';

export const BASE_URL_SERVER = new InjectionToken('_baseUrlServer');
export const SECURITY_API = new InjectionToken('_securityApi');
export const BUSINESS_API = new InjectionToken('_regularApi');

/**
 * Api is a generic REST Api handler. Set your API url first.
 */
@Injectable()
export class Api {
  constructor(private http: HttpClient, @Inject(BASE_URL_SERVER) private baseUrl: string) {}

  get<T>(endpoint: string, options?: any) {
    options = this._defaultOptions(options);
    return this.http.get<T>(`${this.baseUrl}/${endpoint}`, {
      headers: new HttpHeaders(options.headers ? options.headers.toJSON() : undefined),
      params: new HttpParams({ fromString: options.params ? options.params.toString() : '' }),
      // responseType: this._convertResponseType(options),
      withCredentials: options.withCredentials,
    });
  }

  post<T>(endpoint: string, body: any, options?: any) {
    options = this._defaultOptions(options);
    return this.http.post<T>(`${this.baseUrl}/${endpoint}`, body, {
      headers: new HttpHeaders(options.headers ? options.headers.toJSON() : undefined),
      params: new HttpParams({ fromString: options.params ? options.params.toString() : '' }),
      withCredentials: options.withCredentials,
    });
  }

  put<T>(endpoint: string, body: any, options?: any) {
    options = this._defaultOptions(options);
    return this.http.put<T>(`${this.baseUrl}/${endpoint}`, body, {
      headers: new HttpHeaders(options.headers ? options.headers.toJSON() : undefined),
      params: new HttpParams({ fromString: options.params ? options.params.toString() : '' }),
      withCredentials: options.withCredentials,
    });
  }

  delete<T>(endpoint: string, options?: any) {
    options = this._defaultOptions(options);
    return this.http.delete<T>(`${this.baseUrl}/${endpoint}`, {
      headers: new HttpHeaders(options.headers ? options.headers.toJSON() : undefined),
      params: new HttpParams({ fromString: options.params ? options.params.toString() : '' }),
      withCredentials: options.withCredentials,
    });
  }

  patch<T>(endpoint: string, body: any, options?: any) {
    options = this._defaultOptions(options);
    return this.http.patch<T>(`${this.baseUrl}/${endpoint}`, body, {
      headers: new HttpHeaders(options.headers ? options.headers.toJSON() : undefined),
      params: new HttpParams({ fromString: options.params ? options.params.toString() : '' }),
      withCredentials: options.withCredentials,
    });
  }

  private _defaultOptions(requestOptions = {} as any) {
    // TODO:
    // if(requestOptions.params && requestOptions.params.paramsMap) {
    //   let urlParms = new URLSearchParams('', new CustomQueryEncoder());
    //   urlParms.paramsMap = requestOptions.params.paramsMap;
    //   requestOptions.params = urlParms;
    // }
    // if (this.defaultOptions)  {
    //   this.defaultOptions.headers.keys().forEach(key => {
    //     requestOptions.headers.set(key,this.defaultOptions.headers.get(key));
    //   });
    //   requestOptions = this.defaultOptions.merge(requestOptions);
    // }

    return requestOptions;
  }
}
